import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iconPackSelect", "iconGrid", "iconRadio", "customIconField"]

  connect() {
    // Listen for custom icon uploads
    if (this.hasCustomIconFieldTarget) {
      this.customIconFieldTarget.addEventListener('change', (e) => {
        if (e.target.files.length > 0) {
          this.customIconUploaded()
        }
      })
      this.customIconFieldTarget.addEventListener('direct-upload:end', () => {
        this.customIconUploaded()
      })
    }

    // Listen for form submission to debug
    const form = this.element.closest('form')
    if (form) {
      form.addEventListener('submit', (e) => {
        this.debugFormSubmission(e)
      })
    }
  }

  iconSelected(event) {
    // Clear any custom icon when icon pack icon is selected
    this.clearCustomIcon()

    // Update visual selection
    this.iconGridTarget.querySelectorAll('.icon-select-img').forEach(img => img.classList.remove('icon-selected'))
    if (event.target.checked) {
      event.target.nextElementSibling.classList.add('icon-selected')
    }

    // Update the display
    this.updateIconDisplay()
  }

  customIconUploaded() {
    // Clear icon pack selection when custom icon is uploaded
    this.clearIconPackSelection()

    // Uncheck all radio buttons
    this.iconGridTarget.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.checked = false
    })

    // Remove visual selection
    this.iconGridTarget.querySelectorAll('.icon-select-img').forEach(img => img.classList.remove('icon-selected'))
  }

  clearIconPackSelection() {
    if (this.hasIconPackSelectTarget) {
      this.iconPackSelectTarget.value = ''
    }

    // Uncheck all radio buttons
    this.iconGridTarget.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.checked = false
    })

    this.updateIconDisplay()
  }

  clearCustomIcon() {
    // Clear the file input field (this is safe to do)
    const customIconField = this.element.querySelector('input[type="file"]')
    if (customIconField) {
      customIconField.value = ''
    }

    // DO NOT clear the hidden signed_id field - let the direct upload controller handle this
    // The direct upload controller will manage the submit button state based on its own logic
    // We don't want to interfere with its state management
  }

  updateIconDisplay() {
    // This method can be used to update the display when needed
    // For now, we'll let the server-side logic handle the display
  }

  debugFormSubmission(event) {
    // Debug method for form submission (can be removed in production)
  }
}
